export const defaultTechIconSize = "9";
export const biggestIcon = "10";

export const technologies = [
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/GithubActions.png",
    name: "github",
    color: "#2289FF",
    size: "10",
    experience: "60%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/AWS.png",
    name: "aws",
    color: "#FF9A00",
    size: "10",

    experience: "50%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/SalesForce.png",
    name: "github",
    color: "#2289FF",
    size: "7.5",
    experience: "40%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/React.png",
    name: "react",
    color: "#61DAFB",
    size: defaultTechIconSize,
    experience: "90%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/ReactNative.png",
    name: "reactNative",
    color: "#61DAFB",
    size: defaultTechIconSize,
    experience: "80%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/Laravel.png",
    name: "laravel",
    color: "#F35045",
    size: "8",
    experience: "20%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/NodeJS.png",
    name: "nodeJS",
    color: "#619A58",
    size: defaultTechIconSize,
    experience: "60%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/Jest.png",
    name: "jest",
    color: "#99424F",
    size: "7",
    experience: "60%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/HTML.png",
    name: "HTML",
    color: "#DD512A",
    size: "8",

    experience: "65%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/JS.png",
    name: "js",
    color: "#DAB92D",
    size: "8",

    experience: "90%",
  },
  {
    imgSrc: process.env.PUBLIC_URL + "/Images/Technologies/TS.png",
    name: "github",
    color: "#2289FF",
    size: "7.5",
    experience: "75%",
  },
];
